import { useMutation } from '@tanstack/react-query';
import { requestHandler } from 'lib/api';
import { errorHandler } from 'lib/functions/errors';
import { Dispatch } from 'redux';

import { CreateFormPruffConnect } from './types';

export const createSGRWarrantyRequest = (dispatch: Dispatch) =>
  useMutation({
    mutationKey: ['create', 'sgrWarrantyRequest', 'pruffConnect'],
    mutationFn: async (params: {
      data: CreateFormPruffConnect;
      secretId: string;
    }) => {
      const { data, secretId } = params;
      const response = await requestHandler({
        method: 'post',
        url: `internal/express/${secretId}/sgrWarrantyRequest`,
        dispatch,
        data,
      });
      if (response) return response.data;
    },
    onError: (error) => errorHandler(dispatch, error),
  });

export const submitSGRWarrantyRequest = (dispatch: Dispatch) =>
  useMutation({
    mutationKey: ['submit', 'sgrWarrantyRequest', 'pruffConnect'],
    mutationFn: async (params: { id: number; secretId: string }) => {
      const { id, secretId } = params;
      const response = await requestHandler({
        method: 'put',
        url: `internal/express/${secretId}/sgrWarrantyRequest/${id}/submit`,
        dispatch,
      });
      if (response) return response.data;
    },
    onError: (error) => errorHandler(dispatch, error),
  });
